import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@env/environment';
import { getSelectedTenantId } from '../tenant-selection';
import { KIOSK_DEVICE_PATH_SEGMENT } from '@modules/kiosk-device/kiosk-token.interceptor';

// Carries the session's company to the backend as X-Tenant-Id — for EVERY user, not just super-admins.
//
// A multi-org regular user previously sent no header at all, so the server re-derived the tenant from their
// default membership on each request. Nothing in the request named the company, so a link (a task, a
// notification, a pasted URL) resolved against whichever tenant that default happened to be — which could
// differ from the one on screen, and silently recorded work in the wrong organisation.
//
// This is safe because the id is SEEDED FROM THE SERVER'S OWN ANSWER (AuthService.loadContext stores
// ctx.activeTenantId), so it is always a real, currently-active membership rather than a client guess — and
// TenantResolutionMiddleware still rejects a header the caller has no Active membership for. That is what
// the old "a stale/foreign id would 403 everything" caveat was guarding against.
//
// The /auth BFF endpoints are skipped by TenantResolutionMiddleware, so don't tag them — nor kiosk-device
// calls, which resolve their tenant from the device token itself.
export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  if (
    !req.url.startsWith(environment.apiBaseUrl) ||
    req.url.includes('/auth/') ||
    req.url.includes(KIOSK_DEVICE_PATH_SEGMENT)
  ) {
    return next(req);
  }

  const tenantId = getSelectedTenantId();
  return next(tenantId ? req.clone({ setHeaders: { 'X-Tenant-Id': tenantId } }) : req);
};
